import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import React from 'react'
import { useController } from 'react-hook-form'

const HFDropdown = (props) => {
	const { name, optionsAlign, onChange, ...attributes } = props
	const {
		field: { ref, ...field },
	} = useController({ name })

	return (
		<Dropdown
			optionsAlign={optionsAlign}
			{...attributes}
			{...field}
			onChange={(e) => {
				onChange?.(e)
				field.onChange?.(e)
			}}
		/>
	)
}

export default HFDropdown
